import React from 'react'

type LoginContextProps = {
  ssn: string
  setSsn: (ssn: string) => void
  authenticate: (ssn: string) => void
  cancelAuthenticate: () => void
  bankIdSignup: boolean
  setBankIdSignup: (bankIdSignup: boolean) => void
}

const LoginContext = React.createContext<LoginContextProps>({
  ssn: '',
  setSsn: () => {},
  authenticate: () => {},
  cancelAuthenticate: () => {},
  bankIdSignup: false,
  setBankIdSignup: () => {},
})

export const LoginProvider = LoginContext.Provider
export const LoginConsumer = LoginContext.Consumer
export default LoginContext
